export default __webpack_public_path__ + "static/media/dac-logo.67a0b20a.svg";